import React, { useState } from "react";

import { Button, Icon } from "@src/components/atoms";

const MultiLevelMenu = (props) => {
  const {
    selected,
    options,
    main,
    mainSelected,
    onSelect,
    onSelectMain,
    onAddToColumn,
    showSearch = true,
    showAddButton = true,
  } = props;
  const columns = [];
  const [searchQueries, setSearchQueries] = useState([]);

  const boxStyle = "p-1.5 flex justify-between";
  const selectedStyle = "bg-primary-100 font-bold";

  const getLevel = (obj, count) => {
    let list = [];

    const options = [];
    list = Object.keys(obj).map((option) => {
      options.push(option);
      searchQueries.push("");
      let containsLevel = typeof obj[option] === "object";
      return (
        <div
          key={option}
          className={`${boxStyle} ${selected.length > count && selected[count] === option ? selectedStyle : ""} ${
            searchQueries[count] && option.includes(searchQueries[count])
              ? "font-bold"
              : ""
          } hover:bg-gray-200 cursor-pointer`}
          onClick={() => onSelect(count, option, !containsLevel)}
        >
          <span className="w-52 truncate">{option}</span>
          <span>{containsLevel ? ">" : ""}</span>
        </div>
      );
    });
    if (showSearch) {
      list.unshift(
        <div key="search">
          <input
            type="text"
            value={searchQueries[count]}
            id={`inputReplacementsColumn${count}`}
            list={`replacementsColumn${count}`}
            className="input-list m-2 border rounded-md block w-11/12 pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
            placeholder="Search..."
            onChange={(e) => {
              let value = e.target.value;
              let searchUpdate = [...searchQueries];
              searchUpdate[count] = value;
              setSearchQueries(searchUpdate);
              //if there is an exact match, select it
              if (options.indexOf(value) > -1) {
                onSelect(count, value, typeof obj[value] === "string");
              } else {
                //if its a longer match separated by "__", iterate through columns if possible
                let parts = value.split("__");
                if (
                  parts.length > 1 &&
                  parts[0] === "en" &&
                  ["shipping", "aviation"].includes(parts[1])
                ) {
                  //Hacky: remove "en__shipping" / "en__aviation"
                  parts = parts.slice(2);
                }
                if (parts.length > 1) {
                  let objCurrent = obj;
                  parts.forEach((part, i) => {
                    objCurrent = objCurrent?.[part];
                    searchUpdate[count + i] = part;
                    try {
                      onSelect(count + i, part, typeof objCurrent === "string");
                      document
                        .getElementById(`inputReplacementsColumn${count + i}`)
                        .select();
                    } catch (e) {
                      console.error(e);
                      return;
                    }
                  });
                  setSearchQueries(searchUpdate);
                }
              }
            }}
          />
          <datalist id={`replacementsColumn${count}`}>
            {options.map((option) => (
              <option key={option}>{option}</option>
            ))}
          </datalist>
        </div>,
      );
    }
    if (showAddButton) {
      list.push(
        <div key="addBtn" className="absolute bottom-0 w-full">
          <Button onClick={() => onAddToColumn(count)}>
            <div className="flex justify-center">
              <Icon
                name="plus"
                backgroundColor="transparent"
                size="lg"
                textColor="white"
                centered={false}
                padding={false}
              />
              <div className="my-auto">Add</div>
            </div>
          </Button>
        </div>,
      );
    }
    return list;
  };

  let count = 0;
  const alreadyAccessed = [];
  columns.push(getLevel(options, count));
  count++;
  selected.forEach((value) => {
    alreadyAccessed.push(value);
    let next = alreadyAccessed.reduce(
      (prev, curr) => prev && prev[curr],
      options,
    );
    if (typeof next === "object") {
      columns.push(getLevel(next, count));
      count++;
    }
  });

  const scrollLeft = () => {
    let interval = setInterval(() => {
      const element = document.getElementById(`columnList`);
      if (element) {
        clearInterval(interval);
        element.scrollTo({
          left: 10000000,
          behavior: "smooth",
        });
      }
    }, 100);
  };

  return (
    <div className="flex max-w-full w-max-content h-128 max-h-screen border-1 custom-scroll m-4">
      {main && (
        <nav className="w-40 border-r-2 bg-gray-200">
          {main.map((value) => (
            <div
              key={value}
              className={`flex ${boxStyle} w-40 ${mainSelected === value ? selectedStyle : ""}`}
              onClick={() => onSelectMain(value)}
            >
              {value.toUpperCase()}
              {/* {mainSelected === value && <span className="text-gray-600 text-sm">({mainReplacementsCount})</span>} */}
            </div>
          ))}
        </nav>
      )}
      <div
        id="columnList"
        className="flex max-w-full overflow-x-auto overflow-y-auto"
        onClick={scrollLeft}
      >
        {columns.map((value, idx) => (
          <div
            key={idx}
            style={{ display: "inline-table" }}
            className="column border-r-2 w-60 overflow-y-auto overflow-x-hidden h-full relative"
          >
            <div className="overflow-y-auto overflow-x-hidden h-full pb-16">
              {value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MultiLevelMenu;
